import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=03359dcb&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03359dcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03359dcb')) {
      api.createRecord('03359dcb', component.options)
    } else {
      api.reload('03359dcb', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=03359dcb&scoped=true&", function () {
      api.rerender('03359dcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2drp50WKJzEMO/JS/comp/Accordion.vue"
export default component.exports